import { render, staticRenderFns } from "./AlterStorageSpaceUpgradeTipsModal.vue?vue&type=template&id=7adfb966&scoped=true"
import script from "./AlterStorageSpaceUpgradeTipsModal.vue?vue&type=script&lang=js"
export * from "./AlterStorageSpaceUpgradeTipsModal.vue?vue&type=script&lang=js"
import style0 from "./AlterStorageSpaceUpgradeTipsModal.vue?vue&type=style&index=0&id=7adfb966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfb966",
  null
  
)

export default component.exports